import { Group, Typography, Wrapper } from '@screentone/core';
import { format } from 'date-fns-tz';
import { cloneDeep } from 'lodash';

import { ModuleRibbonIndicator } from 'components/datamodel/container/Module/components/module-ribbon-indicator/ModuleRibbonIndicator';
import { Preview } from 'components/preview/Preview';
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { usePageLock } from 'contexts/page-lock/usePageLock';
import { usePagePublish } from 'contexts/page-publish-dto/usePagePublish';
import { SectionContainer } from 'data/generated/graphql';

export const PageDraftSection = () => {
  const { root, metadata, renderEntity, countContent, getSectionAttributes } = useDataModelContext<SectionContainer>();
  const { originalPageWhenInHistoryEditMode } = usePagePublish();
  const { state } = usePageLock();
  const publishingState = state.publishing;

  const { ribbonUrl } = getSectionAttributes();

  const draftSection = renderEntity(cloneDeep(root), {
    hierarchyId: '',
    isReadOnly: publishingState.isReadOnly
  });

  return (
    <Wrapper>
      <Group data-testid="page-draft-title" direction="row" align="space-between" fullWidth valign="baseline">
        <Typography variant="header3">
          {originalPageWhenInHistoryEditMode
            ? `Editing: ${format(metadata.publishUtc!, 'MMM d, yyyy h:mm aaa z')}`
            : `${countContent(root)}`}
        </Typography>
        <Preview />
      </Group>
      {ribbonUrl && <ModuleRibbonIndicator ribbonUrl={ribbonUrl} withBackground />}
      {draftSection}
    </Wrapper>
  );
};
